const resolveNextStepPath = (nextStepPath: string, prospectId: string, quoteId?: string) => {
  return nextStepPath.replace(':prospect_id', prospectId).replace(':quote_id', quoteId || '')
}

export { resolveNextStepPath }
